import React, { useState } from 'react';
import { TextField, Typography, Box, Switch, Button, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const SearchBar = ({ searchTerm, setSearchTerm, showOnlyActive, setShowOnlyActive, onRefresh, filterTexts = {} }) => {
  const [loading, setLoading] = useState(false); // Estado para controlar la carga

  const handleRefresh = async () => {
    setLoading(true); // Iniciar indicador de carga
    await onRefresh(); // Llamar a la función de refrescar
    setLoading(false); // Detener indicador de carga una vez finalizado
  };

  // Establecer valores predeterminados si filterTexts está indefinido
  const {
    buttonReloadText = 'Recargar',
    fieldSearchText = 'Buscar',
    fieldSwitchText = 'Mostrar solo activos'
  } = filterTexts;

  return (
    <Box 
      sx={{ 
        backgroundColor: 'background.default',
        padding: 2,
        borderRadius: 1,
        width: '100%',
        maxWidth: '1200px',
        display: 'flex',
        alignItems: 'center',
        mt: 1,
      }}
    >
      <Typography variant="subtitle1" gutterBottom sx={{ mr: 2, color: 'text.primary' }}>
        {fieldSearchText}
      </Typography>
      <TextField
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          width: '100%',
          maxWidth: '600px',
          '& .MuiInputBase-root': {
            height: '40px',
          },
          '& .MuiOutlinedInput-input': {
            padding: '10px 14px',
          },
          mt: 1,
        }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>{fieldSwitchText}</Typography>
        <Switch
          checked={showOnlyActive}
          onChange={(e) => setShowOnlyActive(e.target.checked)}
        />
        <Button
          variant="contained"
          sx={{ ml: 2, flexGrow: 1 }}
          startIcon={!loading && <RefreshIcon />} // Mostrar ícono solo si no está cargando
          onClick={handleRefresh} // Llama a la función de refrescar
          disabled={loading} // Desactivar botón mientras carga
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : buttonReloadText}
        </Button>
      </Box>
    </Box>
  );
};

export default SearchBar;